import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";
import Header from "../common/containers/Header";
import Menu from "../common/components/Menu";
import { noMenuLayoutLocations, noCheckLoginLocations } from "../utils/http";
import { ColorDiv, GlobalTooltipStyles } from "./ColorDiv";

const Layout = ({
  children,
  getLocalConfigurator,
  getFamilyProductsRequest,
  location,
  localConfigurator,
  checkIfLogged,
  getLocalEDECIntegration,
}) => {
  useEffect(() => {
    // check if user is logged in unless the route is into the noCheckLoginLocations array
    if (
      !noCheckLoginLocations.includes(location.pathname) &&
      !(location.search && location.search.includes("preventCheck=true"))
    ) {
      checkIfLogged();
    }
    getLocalConfigurator();
    getFamilyProductsRequest();
  }, [getLocalConfigurator, getFamilyProductsRequest]); //eslint-disable-line

  useEffect(() => {
    if (localConfigurator.id) {
      getLocalEDECIntegration();
    }
  }, [localConfigurator.id]); //eslint-disable-line

  const colors = {
    headerColor:
      localConfigurator && localConfigurator.color
        ? localConfigurator.color
        : null,
    bannerColor:
      localConfigurator &&
      localConfigurator.theme &&
      localConfigurator.theme.colors
        ? localConfigurator.theme.colors.primary
        : null,
    tooltipColor:
      localConfigurator &&
      localConfigurator.theme &&
      localConfigurator.theme.colors
        ? localConfigurator.theme.colors.secondary
        : null,
    interactionColor:
      localConfigurator &&
      localConfigurator.theme &&
      localConfigurator.theme.colors
        ? localConfigurator.theme.colors.primaryText
        : null,
    textBlack: "#2F2B3D",
    textPrimaryBlack: "#2F2B3DE5",
    textPrimaryBlackDisabled: "#2F2B3D66",
    textSecondaryBlack: "#2F2B3DB2",
    textTableBlack: "#1B2942",
    errorColor: "#FF4C51",
  };

  return noMenuLayoutLocations.includes(location.pathname) ? (
    <>
      <GlobalTooltipStyles {...colors} />
      <ColorDiv {...colors}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{localConfigurator?.title || ""}</title>
        </Helmet>
        <div id="main" className="app-content content">
          <div className="content-overlay" />
          <div className="content-wrapper">
            {children}
            <ToastContainer theme="colored" />
          </div>
        </div>
      </ColorDiv>
    </>
  ) : (
    <>
      <GlobalTooltipStyles {...colors} />
      <ColorDiv {...colors}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{localConfigurator?.title || ""}</title>
        </Helmet>
        <Header />
        <Menu
          pathname={location ? location.pathname : "/"}
          localConfigurator={localConfigurator}
        />
        <div
          id="main"
          className="app-content content"
          style={{ paddingTop: "57px" }}
        >
          <div
            className={
              location.pathname !== "/calculs" &&
              !/\/folders\/[^/]+/.test(location.pathname)
                ? "content-wrapper"
                : "table-page-wrapper"
            }
          >
            {children}
            <ToastContainer theme="colored" />
          </div>
        </div>
      </ColorDiv>
    </>
  );
};

export default Layout;
